
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/styleguide",
      function () {
        return require("private-next-pages/styleguide.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/styleguide"])
      });
    }
  